import type { TSkuCharacteristic } from '../models/sku-characteristic';
import { Product } from '../models/product-legacy';
import type {
  ProductPageQuery,
} from '@/shared/apollo-api/__generated__/types';
import { ProductPaymentOptionType } from '@/shared/apollo-api/__generated__/types';
import { skuCharacteristicMapper } from './sku-characteristic';
import { EProductOptionDtoTypes } from '@/features/product-page/models/product-legacy'

// TODO: Import KOPECKS_IN_RUB from proper location
const KOPECKS_IN_RUB = 100;

export interface ISkuItemCharacteristic extends Omit<TSkuCharacteristic, 'values'> {
  value: TSkuCharacteristic['values'][number];
}

export interface ISkuItem extends Omit<Product.SKU, 'characteristics'> {
  characteristics: ISkuItemCharacteristic[];
  discountTimer?: NonNullable<ProductPageQuery['product']['skuList'][0]['discountTimer']>;
  video?: string;
  skuGroupId?: number;
}

export const mapVat = (vat: NonNullable<ProductPageQuery['product']['skuList'][0]['vat']>): ISkuItem['vat'] => ({
  ...vat,
  price: vat.price / KOPECKS_IN_RUB,
  type: vat.type as any, // TODO: Fix VAT type mapping
});

/**
 * Функция преобразует список SKU продукта. Маппит характеристики к SKU.
 * @param {ProductPage_product} product - Выбранный продукт.
 * @return {ISkuItem[]} список SKU продукта.
 */
export function productToSkuList(product: ProductPageQuery['product']): ISkuItem[] {
  const skuList = product.skuList;

  return skuList.map((sku) => ({
    id: sku.id,
    skuGroupId: sku.skuGroup?.id,
    characteristics: skuCharacteristicMapper(sku.characteristicValues),
    fullPrice: sku.fullPrice,
    purchasePrice: sku.sellPrice,
    availableAmount: sku.availableAmount,
    offer: undefined,
    vat: sku.vat ? mapVat(sku.vat) : undefined,
    charityProfit: undefined,
    discountBadge: sku.discountBadge || undefined,
    discountTimer: sku.discountTimer || undefined,
    video: sku.video?.url,
    productOptionDtos: (sku.paymentOptions || []).map((option) => ({
      active: option.active,
      optionId: option.id,
      paymentInfo: option.paymentInfo || '',
      text: option.text,
      titleBanner: option.type,
      type: (() => {
        switch (option.type) {
          case ProductPaymentOptionType.Dolyame:
            return EProductOptionDtoTypes.DOLYAME;
          case ProductPaymentOptionType.Installment:
            return EProductOptionDtoTypes.INSTALLMENT;
          case ProductPaymentOptionType.Podeli:
            return EProductOptionDtoTypes.PODELI;
          default:
            return EProductOptionDtoTypes.DOLYAME;
        }
      })(),
    })),
  }));
}
